import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';

import { useGetApprovalPaths } from '@/modules/settings/approvals/apiHooks';
import ApprovalDetails from '@/modules/settings/approvals/components/Operations/ApprovalDetails';
import CollapseHeader from '@/modules/settings/approvals/components/shared/CollapseHeader';
import { Loading, Pagination } from '@/shared/components/atoms';
import Collapse from '@/shared/components/atoms/Collapse';
import { EmptyCard } from '@/shared/components/molecules';
import { useStore } from '@/shared/hooks/context/createGenericContext';

const PER_PAGE = 10;

const ApprovalsPaths = () => {
  const { t } = useTranslation('common');
  const [page, setPage] = useState(1);
  const onPageChange = (page: number) => {
    setPage(page);
  };
  const [selectedAsset] = useStore((store) => store?.asset);
  const { data, isLoading } = useGetApprovalPaths({
    pageNumber: page,
    pageSize: PER_PAGE,
    entityId: selectedAsset?.id,
  });

  if (isLoading) {
    return <Loading />;
  }
  if (data?.approvalPaths.length === 0) {
    return (
      <EmptyCard
        classeName='bg-white rounded-2xl p-40'
        variant='text'
        message={t('no-approvals-paths')}
      />
    );
  }
  return (
    <div className='flex flex-col gap-16 rounded-2xl bg-background-neutral-99'>
      <div className='flex flex-col gap-16'>
        {data?.approvalPaths.map((approvalPath, idx) => (
          <Collapse
            key={`approval-path-${idx}`}
            header={<CollapseHeader name={approvalPath.name} />}
            containerClassName='rounded-2xl bg-background-neutral-100'
            childrenPadding='px-0'
            bgColor='bg-background-neutral-100'
            itemClassName='rounded-2xl'
            containerPadding='p-20'
          >
            <ApprovalDetails
              id={approvalPath.id}
              entityId={selectedAsset?.id as number}
            />
          </Collapse>
        ))}
      </div>
      <div className='flex items-center py-16'>
        <Pagination
          onPageChange={onPageChange}
          currentPage={page}
          totalCount={data?.totalCount || 0}
          perPage={PER_PAGE}
        />
      </div>
    </div>
  );
};
export default ApprovalsPaths;
